import React from 'react';
import logo from '../../assets/images/logo.svg';

function Footer({ className }) {
    return (
        <>
            <section className={`moelist-footer-area ${className || ''}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="footer-about-widget">
                                <div className="logo">
                                    <a href="#">
                                        <img src={logo} alt="" />
                                    </a>
                                </div>
                                <p>Another unofficial Android MAL client</p>
                                <a href="#">
                                    Read More <i className="fal fa-arrow-right" />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <div className="footer-navigation">
                                <h4 className="title">Download</h4>
                                <ul>
                                    <li>
                                        <a
                                            rel="noreferrer"
                                            href="https://play.google.com/store/apps/details?id=com.axiel7.moelist"
                                            target="_blank"
                                        >
                                            From Play Store
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            rel="noreferrer"
                                            href="https://apt.izzysoft.de/fdroid/index/apk/com.axiel7.moelist"
                                            target="_blank"
                                        >
                                            From IzzyOnDroid
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            rel="noreferrer"
                                            href="https://github.com/axiel7/MoeList/releases/latest"
                                            target="_blank"
                                        >
                                            From Github
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-navigation">
                                <h4 className="title">Other Links</h4>
                                <ul>
                                    <li>
                                        <a
                                            rel="noreferrer"
                                            href="https://crowdin.com/project/moelist"
                                            target="_blank"
                                        >
                                            Crowdin
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            rel="noreferrer"
                                            href="https://github.com/axiel7/MoeList"
                                            target="_blank"
                                        >
                                            Github
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            rel="noreferrer"
                                            href="https://ko-fi.com/axiel7"
                                            target="_blank"
                                        >
                                            Ko-Fi
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            rel="noreferrer"
                                            href="https://axiel7.github.io"
                                            target="_blank"
                                        >
                                            Creator
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget-info">
                                <h4 className="title">Support</h4>
                                <ul>
                                    <li>
                                        <a href="mailto://contacto.axiel7@gmail.com">
                                            <i className="fal fa-envelope" />
                                            contacto.axiel7@gmail.com
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto://support@lunoxia.de">
                                            <i className="fal fa-globe" /> support@lunoxia.de
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            rel="noreferrer"
                                            href="https://discord.gg/CTv3WdfxHh"
                                            target="_blank"
                                        >
                                            <i className="fab fa-discord" /> discord.gg/CTv3WdfxHh
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="footer-copyright d-flex align-items-center justify-content-between pt-35">
                                <div className="apps-download-btn">
                                    <ul>
                                        <li>
                                            <a
                                                rel="noreferrer"
                                                href="https://lunoxia.net/impressum-datenschutz.html"
                                                target="_blank"
                                            >
                                                Imprint & Privacy
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="copyright-text">
                                    <p>Copyright © 2025 Lunoxia All rights reserved.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Footer;
